import { JSONSchema7 } from 'json-schema';
import { types as commonTypes, customSchemas } from '@sitebuilder/common';
import DownloadCSV from './DownloadCSV';

const schema: JSONSchema7 = {
    title: 'DownloadCSV',
    type: 'object',
    properties: {
        styles: {
            type: 'string',
            description: 'A stylesheet',
            default: '',
        },
        ...customSchemas.textSchema.TextSchema.schema,
        ...customSchemas.styleSchema.StyleSchema.schema,
        ...customSchemas.layoutSchema.LayoutSchema.schema,
        downloadbuttonHtml: {
            type: 'string',
            title: 'Download Button HTML',
            default: 'Download CSV',
        },
        downloadFileName: {
            type: 'string',
            title: 'Download File Name',
            default: 'data.csv',
        },
        downloadCsvData: {
            type: 'string',
            title: 'Download CSV Data',
            default: 'heyy, hi, hey',
        },
        isTransformData: {
            type: 'boolean',
            title: 'Transform Data',
            default: false,
        },
    },
    dependencies: {
        ...customSchemas.layoutSchema.LayoutSchema.dependencies,
        isTransformData: {
            oneOf: [
                {
                    properties: {
                        isTransformData: { enum: [true] },
                        functionToTransform: {
                            type: 'string',
                            description: 'Function to transform',
                            default:
                                // eslint-disable-next-line max-len
                                'return (data) => { return { renderSection } }',
                        },
                    },
                },
            ],
        },
    },
};

const groups = [
    {
        'Style Editor': ['styles'],
        ...customSchemas.textSchema.TextSchema.group,
        ...customSchemas.styleSchema.StyleSchema.group,
        ...customSchemas.layoutSchema.LayoutSchema.group,
        Values: ['downloadbuttonHtml', 'downloadFileName', 'downloadCsvData'],
        'Transform Data': ['isTransformData', 'functionToTransform'],
    },
];

const uiSchema = {
    'ui:groups': groups,
    ...customSchemas.textSchema.TextSchema.uiSchema,
    ...customSchemas.styleSchema.StyleSchema.uiSchema,
    ...customSchemas.layoutSchema.LayoutSchema.uiSchema,
    styles: {
        'ui:widget': 'CSSEditor',
    },
    downloadbuttonHtml: {
        'ui:widget': 'CustomTextInput',
    },
    downloadFileName: {
        'ui:widget': 'CustomTextInput',
    },
    downloadCsvData: {
        'ui:widget': 'CustomTextInput',
    },
    isTransformData: { 'ui:widget': 'CustomCheckbox' },
    functionToTransform: { 'ui:widget': 'JSEditor' },
};

const DownloadCSVWidget: commonTypes.IWidget = {
    schema,
    uiSchema,
    templateView: DownloadCSV,
    id: 'DownloadCSV',
    group: 'component',
    contentPlaceHolders: ['children'],
    initialData: () => ({
        downloadbuttonHtml: 'Download CSV',
    }),
};

export default DownloadCSVWidget;
